<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>

export default {
  methods: {
    changehtmlfontseize() {
      function setRemUnit() {
        const htmlWidth = htmlEl.clientWidth // 拿到视口宽度
        const htmlFontSize = htmlWidth / 100
        htmlEl.style.fontSize = htmlFontSize + 'px'
      }
      const htmlEl = document.documentElement //拿到html实例
      setRemUnit()
      window.addEventListener('resize', setRemUnit)
      window.addEventListener('pageshow', function (e) {
        if (e.persisted) {
          setRemUnit()
        }
      })
    }
  },
  created() {
    this.changehtmlfontseize()
  }
}
</script>
<style lang="less">
@import './base.less';
html,
body {
  width: 100%;
  height: 100%;
  background: #f0f0f0;
  overflow: hidden;
  word-break: break-all;
  word-wrap: break-word;
}

#app {
  width: 100%;
  height: 100%;
}

.ivu-select-dropdown {
  ul {
    max-width: 120px;
    padding-top: 8px;
    li {
      width: 100%;
      height: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;/**不换行**/
      display: inline-block;
    }
  }
}
</style>
